import { getDataForMobileAppLinks } from '@/constants/links'
import styles from './MobileAppLinks.module.scss'
import cn from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import { getMobileApps } from '@/store/slices/stagesSlice/stagesSlice'

interface MobileAppLinksProps {
  className?: string
}

export const MobileAppLinks = ({ className = '' }: MobileAppLinksProps) => {
  const reduxState = useSelector<RootState, RootState>(state => state)
  const { data: mobileApps } = getMobileApps(reduxState)

  const buttonLinksData = mobileApps ? getDataForMobileAppLinks(mobileApps) : []

  return (
    <div className={cn(styles.containerLinks, className)}>
      {buttonLinksData.map(link => (
        <a
          target="_blank"
          className={styles.buttonLink}
          key={link.name}
          href={link.link}
          onClick={link.onClick}
        >
          <img src={link.img} alt={link.name} />
        </a>
      ))}
    </div>
  )
}
